import { FormMode } from '../../controls/common/form-mode';
import { ParametersValuesFormContext } from '../parameters/parameters-values-form/parameters-values-form-context';
import { GroupFormContext } from './group-form-context';

export class GroupDetailContext {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.groupContext.mode = value;
        this.paramsContext.formMode = value;
    }

    public editedGroupId: string = null;

    public groupContext: GroupFormContext = new GroupFormContext();

    public paramsContext: ParametersValuesFormContext = new ParametersValuesFormContext();
}
